/* eslint-disable no-unused-vars */
import { yupResolver } from '@hookform/resolvers/yup'
import { Box, Button, CircularProgress } from '@mui/material'
import TimeRecordApi from 'apis/staff/time-record'
import { useAuth } from 'components/auth/AuthProvider'
import CircularPopup from 'components/CircularPopup'
import moment from 'moment'
import { useSnackbar } from 'notistack'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useLoadingStore } from 'stores/loading.store'
import { useStatusStore } from 'stores/status.store'
import * as Yup from 'yup'
import { apiSubmitForm } from '../../../apis/staff/staff'
import constSubmitType, {
  SubmitType,
  TYPE_DATE,
  TYPE_SUBMIT,
  typeChildWedding,
  typeForGet,
  typeFuneral,
  typeInsurance,
  typeMaternity,
  typeMyWedding,
  typeOT,
  typeOTHoliday,
  typeOTWeekend,
  typeOffPay,
  typeOffUnPay,
  typeOut,
  typeSummer,
  typeWFH,
  typeWomen
} from '../../../constants/submitType'
import { useTimeSheetStore } from '../../../stores/timeSheet.store'
import { getDataSubmitToGoogleForm } from '../../../temp/SendDataToGoogleForm'
import { FormSubmitType } from '../../../types/submitFormType'
import { InputField } from '../../formField'
import { AutocompleteField, AutocompleteOption } from '../../formField/AutocompleteField'
import { ConfirmPopup } from './ConfirmPopup'
import { FormBody } from './FormBody'

type SubmitFormProps = {
  initialValues?: FormSubmitType
}

const validForm = (typeSubmit: string) => {
  if (
    typeSubmit === typeWFH.value ||
    typeSubmit === typeForGet.value ||
    typeSubmit === typeOT.value ||
    typeSubmit === typeOTWeekend.value ||
    typeSubmit === typeOTHoliday.value ||
    typeSubmit === typeOut.value
  ) {
    return 'type1'
  } else if (
    typeSubmit === typeOffPay.value ||
    typeSubmit === typeOffUnPay.value ||
    typeSubmit === typeInsurance.value ||
    typeSubmit === typeMaternity.value
  ) {
    return 'type2'
  } else {
    return 'type3'
  }
}

// Validation
const schema = Yup.object()
  .shape({
    typeSubmit: Yup.string().required('Vui lòng chọn loại bạn muốn submit'),
    dateSubmit: Yup.date().when('typeSubmit', (typeSubmit, field) => {
      if (validForm(typeSubmit[0]) === 'type1') {
        return field.required('Vui lòng chọn ngày submit')
      } else {
        return field
      }
    }),
    typeDate: Yup.string().when('typeSubmit', (typeSubmit, field) => {
      if (validForm(typeSubmit[0]) === 'type2') {
        return field.required('Vui lòng chọn loại ngày nghỉ')
      } else {
        return field
      }
    }),
    startDate: Yup.date().when('typeSubmit', (typeSubmit, field) => {
      if (validForm(typeSubmit[0]) === 'type2' || validForm(typeSubmit[0]) === 'type3') {
        return field.required('Vui lòng chọn ngày bắt đầu')
      } else {
        return field
      }
    }),
    endDate: Yup.date().when(['typeSubmit', 'typeDate'], (param, field) => {
      if (validForm(param[0]) === 'type2' && param[1] == 'all_day') {
        return field.required('Vui lòng chọn ngày kết thúc')
      } else {
        return field
      }
    }),
    timeStart: Yup.date().when('typeSubmit', (typeSubmit, field) => {
      if (
        validForm(typeSubmit[0]) === 'type1' &&
        typeSubmit[0] !== typeForGet.value &&
        typeSubmit[0] !== typeWFH.value
      ) {
        return field.required('Vui lòng chọn thời gian bắt đầu')
      } else {
        return field
      }
    }),
    timeEnd: Yup.date().when('typeSubmit', (typeSubmit, field) => {
      if (
        validForm(typeSubmit[0]) === 'type1' &&
        typeSubmit[0] !== typeForGet.value &&
        typeSubmit[0] !== typeWFH.value
      ) {
        return field.required('Vui lòng chọn thời gian kết thúc')
      } else {
        return field
      }
    })
  })
  .required()

export default function FormSubmit({ initialValues }: SubmitFormProps) {
  const setIsOpenSubmitForm = useStatusStore((state) => state.setIsOpenSubmitForm)
  const setIsGlobalLoading = useLoadingStore((state) => state.setIsGlobalLoading)

  const user = useAuth()?.user
  const [valueType, setValueType] = useState<string>('forget')
  const [open, setOpen] = useState(false)
  const [isError, setIsError] = useState(false)
  const [submitMessage, setsubmitMessage] = useState<React.ReactNode>('')
  const [submitTitle, setsubmitTitle] = useState<string>('')
  const [dataSubmit, setDataSubmit] = useState<FormSubmitType>()
  const { enqueueSnackbar } = useSnackbar()
  const [timeRecords, setTimeRecords] = useTimeSheetStore((state) => [
    state.timeRecords,
    state.setTimeRecords
  ])

  const methods = useForm<FormSubmitType>({
    defaultValues: {
      typeSubmit: typeForGet.value,
      typeDate: TYPE_DATE[0].value,
      dateSubmit: new Date()
    },
    resolver: yupResolver(schema)
  })

  useEffect(() => {
    if (initialValues) {
      setValueType(
        constSubmitType.find((item) => item.value === initialValues.typeSubmit)?.value ?? 'forget'
      )
      methods.reset(initialValues)
    }
  }, [initialValues])

  const handleFormSubmit = (formValues: FormSubmitType) => {
    const { typeSubmit, timeStart, timeEnd, dateSubmit, startDate, endDate, typeDate } = formValues
    const submitTypeLabel = constSubmitType.find(
      (item: SubmitType) => item.value === typeSubmit
    )?.label

    switch (typeSubmit) {
      case typeWFH.value:
      case typeForGet.value:
        if (!timeStart && !timeEnd) {
          setsubmitTitle('Có lỗi xảy ra!')
          setIsError(true)
          setsubmitMessage('Bạn cần chọn thời gian bắt đầu hoặc kết thúc!')
          handleClickOpen()
        } else if (timeStart && timeEnd && timeStart.getTime() >= timeEnd.getTime()) {
          setsubmitTitle('Có lỗi xảy ra!')
          setIsError(true)
          setsubmitMessage('Thời gian kết thúc cần lớn hơn thời gian bắt đầu!')
          handleClickOpen()
        } else {
          setsubmitTitle('Confirm thông tin')
          setIsError(false)
          setDataSubmit(formValues)
          setsubmitMessage(
            <>
              Loại submit: &quot;<b className="text-red-500">{submitTypeLabel}</b>&quot; <br />
              Ngày: <b className="text-red-500">{dateSubmit?.toLocaleDateString('en-GB')}</b> <br />
              Thời gian:{' '}
              <b className="text-red-500">
                {timeStart ? (
                  <>
                    {timeStart?.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}
                  </>
                ) : (
                  '[--:--]'
                )}{' '}
                -{' '}
                {timeEnd ? (
                  <>
                    {timeEnd?.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}
                  </>
                ) : (
                  '[--:--]'
                )}
              </b>
            </>
          )

          handleClickOpen()
        }
        break
      case typeOT.value:
      case typeOTWeekend.value:
      case typeOTHoliday.value:
      case typeOut.value:
        if (timeStart && timeEnd && timeStart.getTime() >= timeEnd.getTime()) {
          setsubmitTitle('Có lỗi xảy ra!')
          setIsError(true)
          setsubmitMessage('Thời gian kết thúc cần lớn hơn thời gian bắt đầu!')
          handleClickOpen()
        } else {
          setsubmitTitle('Confirm thông tin')
          setIsError(false)
          setDataSubmit(formValues)
          setsubmitMessage(
            <>
              Loại submit: &quot;<b className="text-red-500">{submitTypeLabel}</b>&quot; <br />
              Ngày: <b className="text-red-500">{dateSubmit?.toLocaleDateString('en-GB')}</b> <br />
              Thời gian:{' '}
              <b className="text-red-500">
                {timeStart ? (
                  <>
                    {timeStart?.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}
                  </>
                ) : (
                  '[--:--]'
                )}{' '}
                -{' '}
                {timeEnd ? (
                  <>
                    {timeEnd?.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}
                  </>
                ) : (
                  '[--:--]'
                )}
              </b>
            </>
          )
          handleClickOpen()
        }
        break
      case typeOffPay.value:
      case typeOffUnPay.value:
      case typeInsurance.value:
        if (
          startDate &&
          endDate &&
          startDate.getTime() > endDate.getTime() &&
          typeDate == 'all_day'
        ) {
          setsubmitTitle('Có lỗi xảy ra!')
          setIsError(true)
          setsubmitMessage('Ngày kết thúc cần lớn hơn hoặc bằng ngày bắt đầu!')
          handleClickOpen()
        } else {
          setsubmitTitle('Confirm thông tin')
          setIsError(false)
          setDataSubmit(formValues)
          if (typeDate == 'all_day') {
            setsubmitMessage(
              <>
                Loại submit: &quot;<b className="text-red-500">{submitTypeLabel}</b>&quot; <br />
                Số ngày:{' '}
                <b className="text-red-500">
                  {differenceInDays(endDate ?? new Date(), startDate ?? new Date()) ?? ''}
                </b>{' '}
                ngày
                <br />
                Thời gian:{' '}
                <b className="text-red-500">
                  {startDate ? <>{startDate?.toLocaleDateString('en-GB')}</> : '[--/--/----]'} -{' '}
                  {endDate ? <>{endDate?.toLocaleDateString('en-GB')}</> : '[--/--/----]'}
                </b>
              </>
            )
          } else {
            setsubmitMessage(
              <>
                Loại submit: &quot;<b className="text-red-500">{submitTypeLabel}</b>&quot; nửa ngày
                <br />
                Ngày: <b className="text-red-500">{startDate?.toLocaleDateString('en-GB')}</b>{' '}
                <br />
              </>
            )
          }

          handleClickOpen()
        }
        break
      default:
        setsubmitTitle('Confirm thông tin')
        setIsError(false)
        setDataSubmit(formValues)
        setsubmitMessage(
          <>
            Loại submit: &quot;<b className="text-red-500">{submitTypeLabel}</b>&quot;
            <br />
            Ngày: <b className="text-red-500">{startDate?.toLocaleDateString('en-GB')}</b> <br />
          </>
        )
        handleClickOpen()
        break
    }
  }

  const onChange = (newValue: AutocompleteOption) => {
    const clearData: FormSubmitType = {
      typeSubmit: '',
      typeDate: TYPE_DATE[0].value,
      dateSubmit: initialValues?.startDate
    }
    clearData.typeSubmit = newValue.value
    methods.reset(clearData)
    setValueType(newValue.value)
  }

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleConfirmSubmitClick = () => {
    if (!user) {
      return
    }
    if (dataSubmit) {
      dataSubmit.email = user.email
    }
    // enqueueSnackbar('Submit thành công!', { variant: 'success' })
    // sendDataToGoogleForm(user?.email, dataSubmit)
    methods.reset()
    // setOpen(false)

    // apiSubmitForm.create(dataSubmit).then(async (res) => {
    //   if (res.status === 201) {
    //     enqueueSnackbar('Submit thành công!', { variant: 'success' })
    //   } else {
    //     enqueueSnackbar('Có lỗi xảy ra!', { variant: 'error' })
    //   }
    // })
    setIsGlobalLoading(true)
    setIsOpenSubmitForm(false)
    setOpen(false)
    const dateSubmit: Date =
      dataSubmit?.dateSubmit || dataSubmit?.startDate || dataSubmit?.endDate || new Date()

    const dataSubmitGoogle = getDataSubmitToGoogleForm(user?.email, dataSubmit)
    apiSubmitForm
      .submitGoogleForm(dataSubmitGoogle)
      .then((res) => {
        if (res.status === 200) {
          setTimeout(() => {
            const timeParams = moment(dateSubmit).format('MM-YYYY')
            const submitMonth = moment(dateSubmit).get('month') + 1
            const submitYear = moment(dateSubmit).get('year')
            TimeRecordApi.syncDataFromGoogleSheet(timeParams)
              .then((res) => {
                enqueueSnackbar('Submit thành công!', { variant: 'success' })
                setIsOpenSubmitForm(false)
                setTimeRecords(submitMonth, submitYear, user.staffCode)
              })
              .finally(() => {
                setIsGlobalLoading(false)
              })
          }, 5000)
        } else {
          enqueueSnackbar('Có lỗi xảy ra!', { variant: 'error' })
        }
      })
      .catch((err) => {
        setIsGlobalLoading(false)
        enqueueSnackbar('Có lỗi xảy ra!', { variant: 'error' })
      })
  }

  const differenceInDays = (startDate: Date, endDate: Date) => {
    return (startDate.valueOf() - endDate.valueOf()) / (1000 * 60 * 60 * 24) + 1
  }

  return (
    <>
      <Box>
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(handleFormSubmit)}>
            <AutocompleteField
              name="typeSubmit"
              control={methods.control}
              label="Chọn loại submit"
              selectedValue={typeForGet.value}
              options={TYPE_SUBMIT}
              onSelected={onChange}
            />

            <FormBody type={valueType} />

            {valueType != typeForGet.value &&
              valueType != typeWFH.value &&
              valueType != typeMyWedding.value &&
              valueType != typeChildWedding.value &&
              valueType != typeMyWedding.value &&
              valueType != typeWomen.value &&
              valueType != typeMyWedding.value &&
              valueType != typeSummer.value &&
              valueType != typeMaternity.value &&
              valueType != typeFuneral.value && (
                <InputField name="reason" control={methods.control} label="Lý do" />
              )}

            <Box mt={3}>
              <Button
                type="submit"
                variant="contained"
                disabled={methods.formState.isSubmitting}
                sx={{ width: { xs: '100%', sm: 'auto' } }}
              >
                {methods.formState.isSubmitting && <CircularProgress size={15} />} SUBMIT
              </Button>
            </Box>
          </form>
        </FormProvider>
      </Box>
      <ConfirmPopup
        open={open}
        submitTitle={submitTitle}
        isError={isError}
        handleClose={handleClose}
        handleConfirmSubmitClick={handleConfirmSubmitClick}
      >
        <span>{submitMessage}</span>
      </ConfirmPopup>

      <CircularPopup />
    </>
  )
}
